export default "__VITE_ASSET__BeO5rA1z__"